<template>
  <span>{{ val }} </span>
</template>

<script>
export default {
  props: {
    row: {},
    cusprop: {
      type: String,
      default: "",
    },
  },
  computed: {
    val() {
      let arr = this.$jsonPath(this.row, this.cusprop).split(",");
      return Number(arr[0]).toFixed(6) + "," + Number(arr[1]).toFixed(6);
    },
  },
};
</script>
